export default __webpack_public_path__ + "static/media/quickswap.6371e41d.png";